// extracted by mini-css-extract-plugin
module.exports = {"item":"_3Ze4G"};